// Import model
import { DataFormActionRequest } from '../models/DataFormActionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataFormActionRequest - handles JSON serialization and deserialization with type validation
 */
export class DataFormActionRequestSerializer {
  /**
   * Deserializes a JSON string into a DataFormActionRequest instance
   */
  static deserialize(json: string): DataFormActionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataFormActionRequest instance
   */
  static fromObject(obj: any): DataFormActionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataFormActionRequest');
    }


    const instance: DataFormActionRequest = {
      action: obj['Action'] as string,
      parameters: obj['Parameters'] as any,
      view: obj['View'] as string | undefined,
      selectedIds: obj['selectedIds'] ? (obj['selectedIds'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataFormActionRequest instances
   */
  static deserializeArray(json: string): DataFormActionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataFormActionRequest instance to a JSON string
   */
  static serialize(instance: DataFormActionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataFormActionRequest instance to a plain object
   */
  static toObject(instance: DataFormActionRequest): any {
    return {
      'Action': instance.action,
      'Parameters': instance.parameters,
      'View': instance.view,
      'selectedIds': instance.selectedIds?.map((item: any) =>
        item
      ),
    };
  }

  /**
   * Serializes an array of DataFormActionRequest instances to a JSON string
   */
  static serializeArray(instances: DataFormActionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
